// 12/08/2026 - Retirada del Service Worker.
//
// La aplicación registraba un Service Worker (CRA lo trae de fábrica) que
// guardaba una copia de la web en el navegador. Traía dos problemas concretos:
//
// 1. Los usuarios veían la versión anterior hasta la SEGUNDA visita después de
//    cada despliegue. Con lo seguido que se corrige aquí, eso significa gente
//    trabajando con una versión vieja sin saberlo.
//
// 2. Durante la migración confundió el diagnóstico más de una vez: el navegador
//    servía copias cacheadas y parecía que el servidor nuevo no respondía.
//
// Y ahora se suma un tercero: al mover la aplicación de /remuneraciones/ a la
// raíz, el Service Worker antiguo quedaría registrado con alcance
// /remuneraciones/ e interceptaría esas direcciones ANTES de que la petición
// llegue a nginx. El redirect del servidor nunca se ejecutaría y el usuario
// se quedaría atrapado en la copia vieja.
//
// Esta función no registra nada: da de baja cualquier Service Worker que el
// navegador tenga de antes y borra sus cachés. Se ejecuta en cada arranque;
// cuando ya no queda ninguno no hace nada y no cuesta nada.
//
// Para una aplicación interna que se usa en la red de la universidad, el
// almacenamiento sin conexión no aportaba lo suficiente como para pagar ese
// precio.

export default function limpiarServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.getRegistrations()
    .then(function (registros) {
      registros.forEach(function (registro) {
        registro.unregister();
      });
      if (registros.length > 0) {
        console.info('Se dieron de baja ' + registros.length + ' Service Worker(s) antiguos.');
      }
    })
    .catch(function () { /* si el navegador no deja, no se insiste */ });

  // Las cachés sobreviven a la baja del Service Worker, así que se borran aparte.
  if (window.caches && typeof window.caches.keys === 'function') {
    window.caches.keys()
      .then(function (nombres) {
        nombres.forEach(function (nombre) { window.caches.delete(nombre); });
      })
      .catch(function () { /* idem */ });
  }
}
